@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as c;

.modal {
  padding: 0;
  width: 576px;

  @include c.containerMedia(v.$tablet-breakpoint) {
    max-width: calc(100% - 30px);
  }
}

.contentBox {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: v.$palette-white;
  box-shadow: v.$shadow-2;
  border-radius: 10px;
  text-align: center;
  padding: 48px;

  .title {
    @include t.text(20px, 30px, 600);
    color: v.$palette-gray-900;
    margin-bottom: 8px;
    max-width: 480px;
  }

  .description {
    @include t.text(12px, 20px, 400);
    color: v.$palette-gray-800;
    margin-bottom: 16px;
  }

  .buttonsWrapper {
    display: flex;
    gap: 16px;
  }

  .cancelButton {
    @include t.text(16px, 26px, 600);
    color: v.$palette-gray-900;
    background-color: v.$palette-gray-100;
    padding: 11px 24px;
    border-radius: 8px;
  }

  .deleteButton {
    @include t.text(16px, 26px, 600);
    padding: 11px 24px;
    border-radius: 8px;
  }
  
}

.closeBtn {
  display: block;
  position: absolute;
  padding: 0;
  margin: 0;
  width: 22px;
  height: 22px;
  top: 24px;
  right: 24px;
  color: v.$palette-gray-900;
  cursor: pointer;

  svg path {
    fill: v.$palette-gray-900;
  }
}